<template>
  <div class="home">
    <div class="__highlight">
      <HighlightCarousel :highlights="highlights"></HighlightCarousel>
    </div>

    <div class="mobile-spacer"></div>

    <div class="relative mt-4 mb-3">
      <h2 class="page-title">News<span class="page-title-link"><a :href="'/' + $i18n.locale + '/news'">{{ $t('all_news') }}</a></span></h2>
    </div>

    <div class="__news">
      <ArticlePreview v-for="article of news" :key="article" :article="article"></ArticlePreview>
    </div>

    <!--
    <div class="relative mt-4 mb-3">
      <h2 class="page-title">Instagram</h2>
    </div>
    -->

    <!--
    <div class="mt-4">
      <InstaEmbed id="CfUeAbgLtud" :max-width="320"></InstaEmbed>
    </div>
    -->
  </div>
</template>

<script>
import { defineComponent, computed, reactive } from 'vue'

import { useHead } from '@vueuse/head'

import cmsService from '@/services/cms.service';

import InstaEmbed from '@/components/insta-embed/InstaEmbed.vue';
import HighlightCarousel from '@/components/home/HighlightCarousel.vue';
import ArticlePreview from '@/components/article/ArticlePreview.vue';
import mediaService from '@/services/media.service';

export default defineComponent({
  components: { InstaEmbed, HighlightCarousel, ArticlePreview },

  setup() {
    const siteData = reactive({
      title: `ITF Bruchköbel - ITF Head Cup`,
      description: `Willkommen auf der offiziellen Website des HEAD Cup Bruchköbel operated by Achat Hotels!`,
      thumbnail: '',
      lang: '',
      url: '',
      locale: 'en',
      locale_alternate: 'de',
      ld_json_webpage: '',
      ld_json_website: ''
    })

    useHead({
      title: computed(() => siteData.title),
      htmlAttrs: {
        lang: computed(() => siteData.lang),
      },
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
        // Twitter
        { name: 'twitter:title', content: computed(() => siteData.title) },
        { name: 'twitter:description', content: computed(() => siteData.description) },
        { name: 'twitter:image', content: computed(() => siteData.thumbnail) },
        { name: 'twitter:url', content: computed(() => siteData.url) },
        { name: 'twitter:domain', content: location.origin },
        { name: 'twitter:card', content: 'summary_large_image' },
        // Google+ / Schema.org
        { itemprop: 'name', content: computed(() => siteData.title) },
        { itemprop: 'description', content: computed(() => siteData.description) },
        // Facebook / Open Graph
        { property: 'og:url', content: computed(() => siteData.url) },
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: computed(() => siteData.title) },
        { property: 'og:description', content: computed(() => siteData.description) },
        { property: 'og:image', content: computed(() => siteData.thumbnail) },

        { property: 'og:locale', content: computed(() => siteData.locale) },
        { property: 'og:locale:alternate', content: computed(() => siteData.locale_alternate) },
      ],
      link: [
        { rel: 'canonical', href: computed(() => siteData.url) , id: 'canonical' },
      ],
      script: [
        {
          type: 'application/ld+json',
          children : computed(() => siteData.ld_json_webpage)
        },
        {
          type: 'application/ld+json',
          children : computed(() => siteData.ld_json_website)
        }
      ]
    })

    return {
      siteData
    }
  },

  data() {
    return {
      highlights: [],
      news: [],

      logo: null,
    };
  },

  computed: { },

  methods: {
    getMedia () {
      /* mediaService.getActive().then((data) => {
        this.logo = data.data.logo;
        this.siteData.thumbnail = this.logo;
      })
      */

      this.logo = location.origin + '/logo.svg';
      this.siteData.thumbnail = this.logo;
    },

    getNews () {
      cmsService.getArticlesByFilter(1, 6, ['news'], [], [this.$i18n.locale])
        .then((data) => {
          let _articles = data.data.docs;

          _articles = _articles.map((item) => {
            if('de' in item) {
              item['de'] = JSON.parse(item['de']);
            }

            if('en' in item) {
              item['en'] = JSON.parse(item['en']);
            }

            return item;
          })

          this.news = _articles;

          this.highlights = []
          for(let article of _articles) {
            this.highlights.push(Object.assign({}, article))
          }
        }).catch((error) => {
          this.$vaToast.init({ message: 'Error while loading the page!', color: 'danger' });
        });
    },
  },

  mounted() {
    this.getNews();
    this.getMedia();

    if(this.$i18n.locale == 'de') {
      this.siteData.title = `ITF Bruchköbel - ITF Head Cup`;
      this.siteData.description = `Willkommen auf der offiziellen Website des HEAD Cup Bruchköbel operated by Achat Hotels!`;
      this.siteData.lang = this.$i18n.locale;
      this.siteData.url = location.origin + '/de/';
    } else {
      this.siteData.title = `ITF Bruchkoebel - ITF Head Cup`;
      this.siteData.description = `Welcome to the official website of the HEAD Cup Bruchkoebel operated by Achat Hotels!`;
      this.siteData.lang = this.$i18n.locale;
      this.siteData.url = location.origin + '/en/';
    }

    this.siteData.ld_json_webpage = JSON.stringify({
      "@context": "http://schema.org",
      "@type": "WebPage",
      "name": this.$i18n.locale == 'de' ? `ITF Bruchköbel - ITF Head Cup` : `ITF Bruchkoebel - ITF Head Cup`,
      "description": this.$i18n.locale == 'de' ?  'Willkommen auf der offiziellen Website des HEAD Cup Bruchköbel operated by Achat Hotels!' : `Welcome to the official website of the HEAD Cup Bruchkoebel operated by Achat Hotels!`,
    });

    this.siteData.ld_json_website = JSON.stringify({
      "@context": "http://schema.org",
      "@type": "WebSite",
      "name": this.$i18n.locale == 'de' ? `ITF Bruchköbel - ITF Head Cup` : `ITF Bruchkoebel - ITF Head Cup`,
      "url": location.origin + '/' + this.$i18n.locale,
    })

    this.siteData.locale = this.$i18n.locale;
    this.siteData.locale_alternate = this.$i18n.locale == 'de' ? 'en' : 'de';
  },
})
</script>

<style lang="scss">
  .home {
    .mobile-spacer {
      height: 40px;
    }

    .instagram-media {
      width: 326px !important;
      margin: auto !important;
      margin-top: 12px !important;
      margin-bottom: 12px !important;

      border-radius: 12px !important;

      body {
        overflow: hidden !important;
      }

      .Caption {
        display: none;
      }
    }
  }

  .relative {
    position: relative;

    &:after {
      content: "";
      position: absolute;
      display: block;
      width: 100%;
      height: 0;
      left: 0;
      bottom: 0;
      margin-top: 1px;
      border-bottom: 1px solid #eee;
      z-index: -1;
    }
  }

  .page-title {
    display: inline-block;
    text-transform: uppercase;
    font-size: 24px;
    border-bottom: 2px solid var(--va-primary);
    // font-family: 'Lato-Bold';

    margin-top: 4px;

    a {
      color: #888;
    }

    &-link {
      font-family: 'Lato-Light';
      position: absolute;
      right: 0;
      font-size: 16px;
      top: 12px;
      color: #888;
      cursor: pointer;
      font-weight: 400;
    }
  }

  .__news {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
</style>
